import * as React from 'react';
import classnames from 'classnames';
import styles from '../styles/grid.css';
const gridTypeContext = React.createContext('standard');
/**
 * **Grid Container** is the bbounding box around a fluid grid and
 * comes with a max width based on its `type`
 *
 * Allows adding arbitrary props that are allowed on `div` elements
 * (e.g. `id`, `style` or `title`)
 */
export const GridContainer = ({ type = 'standard', withSidenav = false, className = '', children, ...other }) => {
    const classes = classnames(styles.gridContainer, styles[`${type}GridContainer`], className, { [styles.withSidenav]: withSidenav });
    return (React.createElement(gridTypeContext.Provider, { value: type },
        React.createElement("div", { key: "container", className: classes, ...other }, children)));
};
export const useGridType = () => React.useContext(gridTypeContext);
GridContainer.displayName = 'GridContainer';
//# sourceMappingURL=container.js.map